import Vue from 'vue';
import * as moment from 'moment';

class TimeService {

  constructor() {
    setInterval(() => {
      this.time = moment().locale(Vue.prototype.$languageService.getLanguage());
      Vue.prototype.$eventEmitter.emit(Vue.prototype.$eventEmitter.eventTypes.TIME_TICK, this.time);
    }, 1000)
  }

  convertToHours(time) {
    return moment.duration(time.format('HH:mm:ss')).asHours();
  }

  convertToMinutes(time) {
    return moment.duration(time.format('HH:mm:ss')).asMinutes();
  }
}

export default TimeService;
